/* 關張傳・第 5 章：麥城（建安二十四年，219）
 * 史實：《三國志·關羽傳》「曹公遣徐晃救曹仁，羽不能克，引軍退還。權已據江陵，盡虜羽士眾妻子，羽軍遂散。權遣將逆擊羽，斬羽及子平於臨沮。」
 *       《呂蒙傳》「羽還，在道路，數使人與蒙相聞，蒙輒厚遇其使，周遊城中，家家致問，或手書示信。羽人還，私相參訊，咸知家門無恙，
 *       見待過於平時，故羽吏士無鬬心。會權尋至，羽自知孤窮，乃走麥城，西至漳鄉，眾皆委羽而降。」
 *       《吳主傳》「關羽還當陽，西保麥城。權使誘之。羽偽降，立幡旗爲像人於城上，因遁走，兵皆解散，尚十餘騎。權先使朱然、潘璋斷其徑路。
 *       十二月，璋司馬馬忠獲羽及其子平、都督趙累等於章鄉，遂定荊州。」
 * 流程：1. 羽人還，私相參訊：帶兵往麥城走。派去江陵的使者一個個回來，走進兵堆說「家門無恙」，聽到的兵鬥志大跌，歸零就脫隊。
 *          搶先迎上使者，讓他先向關羽回報，兵聽到的就少；待在關羽身邊的兵鬥志慢慢回升。
 *       2. 偽降・像人：進了麥城，孫權派人來招降。限時內到城頭四處立幡旗像人（站著讀條）。來不及，吳軍入城受降就識破了（失敗）。
 *       3. 因遁走，尚十餘騎：從西門溜出去，避開城外的吳軍巡哨。往西的大路被朱然的鹿角擋住，北、南兩條小路有一條潘璋埋伏。
 *       4. 到章鄉：照史實接結局（被擒是劇情）；最後交代張飛之死與陳壽的評語。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout, vanish, TROOPS, PEOPLE } from '../kit.ts';
import { GZ, spare, calm } from './guanzhang_kit.ts';
import { CITY, START, EGATE, WGATE, ZHANG, BLOCK, SPOTS, TRAILS } from '../maps/guanzhang_maicheng.ts';

const LV = 16, MEN = 16, KEEP = 10, FEINT = 70, NEWS = 70;
const WU = { spec: TROOPS.wu, name: '吳兵', hp: 520, maxHp: 520, atk: 30 };

export default {
  id: 'guanzhang-5', map: 'guanzhang_maicheng', hero: 'guanyu',
  title: '第 5 章　麥城', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '羽偽降，立幡旗爲像人於城上，因遁走，兵皆解散，尚十餘騎。', src: '《三國志·吳書·吳主傳》' }],
    text: '曹操派徐晃救樊城，關羽攻不下，引軍退還。這時孫權已經派呂蒙白衣渡江，取了公安、江陵，關羽將士的家眷全落在吳軍手裡。',
    goals: ['帶兵往麥城：先迎上回來的使者', '偽降：在城頭立起幡旗像人', '帶十餘騎遁走，避開朱然、潘璋', '西至章鄉'],
  },
  words: { ally: '荊州兵', foe: '吳兵' },
  stars: [
    { text: '到麥城時還留著一半以上的兵', ok: (m) => m.vars.keptAtCity >= MEN / 2 },
    { text: '40 秒內立好四個像人', ok: (m) => m.vars.feintT != null && m.vars.feintT < 40 },
    { text: '遁走時沒被吳軍巡哨發現', ok: (m) => !m.vars.spotted },
  ],
  steps: [
    { // 0. 羽人還，私相參訊
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0] - 100; me.y = START[1];
        V.ping = ally(w, GZ.guanping, me.x + 60, me.y + 100, LV - 2);
        V.lei = ally(w, GZ.zhaolei, me.x + 60, me.y - 100, LV - 4);
        V.men = Array.from({ length: MEN }, (_, i) => { const u = m.recruit(me.x + 100 + (i % 4) * 50, me.y - 120 + Math.floor(i / 4) * 80, '荊州兵'); u.spec = TROOPS.shu; u.will = 100; m.join(u, me); return u; });
        V.deserted = 0; V.envoys = [];
        m.card('曹公遣徐晃救曹仁，羽不能克，引軍退還。權已據江陵，盡虜羽士眾妻子。', '《關羽傳》');
        m.line('關羽', '江陵丟了……先退到麥城，再作打算。派人去江陵，問問呂蒙到底想怎樣。');
        m.after(4, () => m.line('提示', '使者回來時會走進兵堆裡說江陵的事，聽到的兵鬥志大跌。搶先迎上使者，讓他先向你回報。兵待在你身邊，鬥志會慢慢回升。'));
        [6, 22, 38].forEach((t, k) => m.after(t, () => {
          const c = V.men.filter((u) => u.alive), cx = c.reduce((s, u) => s + u.x, 0) / (c.length || 1), cy = c.reduce((s, u) => s + u.y, 0) / (c.length || 1); // 從南邊（江陵方向）回來
          const f = m.folk(cx - 200 + k * 200, Math.min(4100, cy + 900), { name: '使者', still: true, near: 1, look: 3 });
          f.walk = true; V.envoys.push(f);
          m.line('荊州兵', '使者回來了！江陵那邊怎麼樣？');
          m.mark('env' + k, f.x, f.y, '使者', false);
          f.k = k;
        }));
        m.after(16, () => { for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', START[0] + 600, START[1] - 200 + i * 130, WU); u.home = [START[0] - 400, START[1]]; } m.line('吳兵', '追！別讓關羽跑了！'); });
        m.mark('city', EGATE[0], EGATE[1], '麥城');
        m.obj('city', '退往麥城');
        m.obj('will', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, men = V.men.filter((u) => u.alive && u.owner === me);
        for (const f of V.envoys) {
          if (f.done) continue;
          // 使者往兵堆中間走；關羽先迎上去，他就只向關羽低聲回報
          if (men.length) { const tx = men.reduce((s, u) => s + u.x, 0) / men.length, ty = men.reduce((s, u) => s + u.y, 0) / men.length, dx = tx - f.x, dy = ty - f.y, L = Math.hypot(dx, dy) || 1; f.x += (dx / L) * 110 * dt; f.y += (dy / L) * 110 * dt; f.f = dx < 0 ? -1 : 1; } // 往兵堆中間走
          m.unmark('env' + f.k); m.mark('env' + f.k, f.x, f.y, '使者');
          const dMe = SG.gd(me.x, me.y, f.x, f.y), dMen = Math.min(...men.map((u) => SG.gd(u.x, u.y, f.x, f.y))), toMe = dMe < 150 && dMe < dMen, toMen = !toMe && dMen < 110; // 關羽先碰到才算迎上
          if (!toMe && !toMen) continue;
          f.done = true; m.unmark('env' + f.k);
          const hit = toMe ? 18 : NEWS;
          if (toMe) { m.line('使者', '（低聲）……將軍，呂蒙待城中家家致問，還有家書。'); m.after(2, () => m.line('關羽', '……此事暫且莫聲張。')); }
          else m.line('使者', ['家裡都好！呂將軍派人挨家挨戶問候，比平時待得還好！', '這是你娘的手書，說家門無恙。', '吳軍不許兵士擅入民家，連一頂斗笠都不敢拿。'][f.k]);
          for (const u of men) if (SG.gd(u.x, u.y, f.x, f.y) < 380) u.will -= hit;
          m.after(4, () => { f.x = -999; });
        }
        // 鬥志：待在關羽身邊慢慢回升；歸零就脫隊回江陵
        for (const u of men) {
          if (SG.gd(u.x, u.y, me.x, me.y) < 300) u.will = Math.min(100, u.will + dt * 1.5);
          if (u.will <= 0) { u.owner = null; u.recruit = false; u.noFight = true; V.deserted++; rout(m, w, [u], [START[0], 4300]); m.line('荊州兵', '家裡都好好的……我不打了。'); }
        }
        const left = V.men.filter((u) => u.alive && u.owner === me);
        m.get('will').text = `兵 ${left.length}／${MEN}（鬥志平均 ${left.length ? Math.round(left.reduce((s, u) => s + u.will, 0) / left.length) : 0}%）`;
        if (!left.length) { m.lose('羽軍遂散：兵全散光了'); return false; }
        return V.envoys.length === 3 && V.envoys.every((f) => f.done) && m.near(me, CITY.x, CITY.y, 260);
      },
    },
    { // 1. 偽降・像人
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.keptAtCity = V.men.filter((u) => u.alive && u.owner === me).length;
        m.done('city'); m.drop('will'); m.unmark('city');
        m.gate('e', EGATE[0], EGATE[1], 170, 'citygate'); m.gate('w', WGATE[0], WGATE[1], 170, 'citygate');
        m.card('會權尋至，羽自知孤窮，乃走麥城。', '《呂蒙傳》');
        m.after(3, () => { m.card('權使誘之。', '《吳主傳》'); m.line('吳使', '吳侯有言：將軍若肯歸降，必以上賓相待。'); });
        m.after(7, () => m.line('關羽', '……告訴吳侯，關某明日開城。（低聲）平兒，城頭插滿旗，紮些草人穿上甲。'));
        // 城外的吳軍與巡哨
        V.watch = [];
        [[3800, 1900, 3800, 3100], [5400, 1900, 5400, 3100], [3500, 2350, 3500, 2650]].forEach(([x1, y1, x2, y2]) => { for (let i = 0; i < 2; i++) { const u = m.foe('huangjin', x1 + i * 60, y1, WU); u.asleep = true; u.untargetable = true; m.patrol(u, [[x1 + i * 60, y1], [x2 + i * 60, y2]]); V.watch.push(u); } });
        V.feint = 0; V.t1 = w.t; V.spots = SPOTS.map(([x, y], k) => { m.mark('s' + k, x, y, '立像人', true); return { x, y, done: false }; });
        m.obj('feint', '在城頭立幡旗像人', 4);
        m.obj('time', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, left = FEINT - (w.t - V.t1);
        V.spots.forEach((s, k) => { if (!s.done) m.chanAt(me, 's' + k, s.x, s.y, 110, 2, '立像人', () => { s.done = true; V.feint++; m.unmark('s' + k); m.folk(s.x, s.y - 20, { name: '像人', still: true, near: 1, draw: dummy }); }); });
        m.prog('feint', V.feint);
        m.get('time').text = `吳軍入城受降之前（還有 ${Math.max(0, Math.ceil(left))} 秒）`;
        if (left <= 0) { m.lose('吳軍入城受降，偽降被識破'); return false; }
        return V.feint >= 4;
      },
    },
    { // 2. 因遁走，尚十餘騎
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.feintT = w.t - V.t1;
        m.done('feint'); m.drop('time');
        V.night = true;
        m.card('立幡旗爲像人於城上，因遁走，兵皆解散，尚十餘騎。', '《吳主傳》');
        const men = V.men.filter((u) => u.alive && u.owner === me);
        men.slice(KEEP).forEach((u) => vanish(w, u)); // 兵皆解散
        m.ungate('w');
        // 朱然在大路上立了鹿角；北、南兩條小路有一條潘璋埋伏
        m.gate('zhu', BLOCK[0], BLOCK[1], 280, 'abatis', ['關平', '父親，大路被朱然的鹿角封死了！']);
        V.zhu = boss(w, PEOPLE.zhuran, BLOCK[0] - 200, BLOCK[1], { name: '朱然', hp: 5000, atk: 50, armor: 10 });
        V.amb = Math.floor(SG.rand() * 2);
        const P = TRAILS[V.amb][2];
        V.pan = boss(w, GZ.panzhang, P[0], P[1], { name: '潘璋', hp: 5600, atk: 54, armor: 10 });
        V.ambush = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', P[0] - 150 + (i % 3) * 150, P[1] - 80 + Math.floor(i / 3) * 160, WU));
        spare(w, V.pan, (u) => { u.untargetable = true; rout(m, w, [u], [P[0], P[1] - 600]); });
        spare(w, V.zhu, (u) => { u.untargetable = true; });
        m.after(2, () => m.line('趙累', '城外有吳軍的巡哨。從西門悄悄出去，往西到章鄉，再轉往益州。'));
        m.after(5, () => m.line('提示', '巡哨靠太近會發現你。大路被擋住了，找小路走；兩條小路有一條有埋伏。'));
        m.mark('zhang', ZHANG[0], ZHANG[1], '章鄉');
        m.obj('zhang', '帶十餘騎西至章鄉');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of V.watch) if (u.alive && u.asleep) {
          u.target = null; u.think = 0.5;
          if (SG.gd(u.x, u.y, me.x, me.y) < 300 && SG.MAP.brushAt(me.x, me.y) < 0) { // 被巡哨看到：吳軍追上來
            V.spotted = true; m.big('被發現了！'); m.line('吳兵', '城頭那些是草人！關羽跑了！');
            for (const o of V.watch) { o.asleep = false; o.untargetable = false; o.patrol = null; }
            for (let i = 0; i < 5; i++) { const o = m.foe('huangjin', CITY.x + 600, CITY.y - 200 + i * 100, WU); o.home = [me.x, me.y]; }
            break;
          }
        }
        if (V.spotted) for (const u of V.watch) if (u.alive) u.home = [me.x, me.y];
        return m.near(me, ZHANG[0], ZHANG[1], 260);
      },
    },
    { // 3. 章鄉
      enter(m, w) {
        const V = m.vars;
        m.done('zhang'); m.unmark('zhang');
        V.night = false;
        m.line('關羽', '……到章鄉了。');
        m.after(3, () => m.card('權先使朱然、潘璋斷其徑路。十二月，璋司馬馬忠獲羽及其子平、都督趙累等於章鄉，遂定荊州。', '《吳主傳》'));
        m.after(10, () => m.card('先主伐吳，飛當率兵萬人，自閬中會江州。臨發，其帳下將張達、范彊殺飛，持其首，順流而奔孫權。', '《張飛傳》'));
        m.after(17, () => m.card('羽報效曹公，飛義釋嚴顏，並有國士之風。然羽剛而自矜，飛暴而無恩，以短取敗，理數之常也。', '陳壽評'));
        m.after(23, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars, me = w.player;
    if (!me.alive) { m.lose('關羽陣亡'); return; }
    calm(w);
    for (const u of [V.ping, V.lei]) if (u) allyTick(w, u, me);
    if (V.watch) for (const u of V.watch) if (u.alive && u.asleep) { u.target = null; u.think = 0.5; }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) {
    if (!m.vars.night) return;
    ctx.fillStyle = 'rgba(12,18,48,.45)'; ctx.fillRect(x0, y0, vw, vh);
  },
};
// 幡旗像人：草人披甲，旁邊一桿旗
function dummy(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.strokeStyle = '#5a3a22'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(18, 0); ctx.lineTo(18, -90); ctx.stroke();
  poly(ctx, [[18, -90], [52 + Math.sin(T * 3) * 4, -84], [18, -66]], '#3e7b50', 1.5);
  poly(ctx, [[-10, 0], [10, 0], [12, -46], [-12, -46]], '#c8b070', 1.6);
  poly(ctx, [[-12, -46], [12, -46], [10, -30], [-10, -30]], '#3e7b50', 1.4);
  ctx.fillStyle = '#c8b070'; ctx.beginPath(); ctx.arc(0, -56, 9, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}
